// extracted by mini-css-extract-plugin
module.exports = {"main":"Z_b","header":"Z_bY","title":"Z_l","author":"Z_fz","date":"Z_P","post":"Z_H","subfooter":"Z_fB","banner":"Z_2"};